<template>
    <div>
        <div class="tinymce-container editor-container" :class="{fullscreen:fullscreen}">
            <textarea :id="tinymceId" class="tinymce-textarea"/>
        </div>
    </div>
</template>

<script>
    import Setting from "../../setting";
    import appUtils from "../../utils/appUtils";
    import dataUtils from '@/utils/dataUtils';

    export default {
        props: {
            value: {
                type: String,
                default: ''
            },
            toolbar: {
                type: Array,
                default() {
                    return []
                }
            },
            menubar: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                tinymceId: 'vue-tinymce-' + +new Date(),
                fullscreen: false,
            }
        },
        watch: {
        },
        created() {

        },
        mounted() {
            this.initTinymce()
        },
        methods: {
            initTinymce() {
                tinymce.init({
                    inline: false,
                    branding: false,
                    fontsize_formats: '12px 14px 16px 18px 20px 24px 36px',
                    language: 'zh_CN',
                    selector: `#${this.tinymceId}`,
                    height: 650,
                    min_height: 400,
                    body_class: 'panel-body ',
                    object_resizing: true,
                    toolbar: ['undo redo bullist  numlist indent outdent blockquote formatselect  autolink directionality code codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount emoticons autosave autoresize'],
                    menubar: 'file  edit format view',
                    menu: {
                        file: {title: '文件', items: 'image media link'},
                        view: {title: '查看', items: 'print preview fullscreen visualblocks visualchars'},
                    },
                    plugins: 'preview,searchreplace,autolink,directionality,visualblocks,visualchars,fullscreen,image,link,media,code,codesample,table,charmap,pagebreak,nonbreaking,anchor,insertdatetime,advlist,lists,wordcount,help,emoticons,autosave,autoresize',
                    end_container_on_empty_block: true,
                    powerpaste_word_import: 'clean',
                    code_dialog_height: 450,
                    code_dialog_width: 1000,
                    advlist_bullet_styles: 'square',
                    advlist_number_styles: 'default',
                    default_link_target: '_blank',
                    link_title: false,
                    convert_urls:false,
                    file_picker_callback: function (callback, value, meta) {
                        //文件分类
                        var filetype = '.pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .mp3, .mp4, .jpg, .jpeg, .png, .gif';
                        //后端接收上传文件的地址
                        var upurl = Setting.apiBaseURL + '/system/file/upload';
                        //为不同插件指定文件类型及后端地址
                        switch (meta.filetype) {
                            case 'image':
                                filetype = '.jpg, .jpeg, .png, .gif';
                                break;
                            case 'media':
                                filetype = '.mp3, .mp4';
                                break;
                            case 'file':
                            default:
                        }

                        //模拟出一个input用于添加本地文件
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', filetype);
                        input.click();
                        input.onchange = function () {
                            let loading = appUtils.showLoading('正在上传，请稍后...')
                            setTimeout(() => {
                                var file = this.files[0];
                                var xhr, formData;
                                xhr = new XMLHttpRequest();
                                xhr.withCredentials = false;
                                xhr.open('POST', upurl);
                                xhr.setRequestHeader ('token', dataUtils.getData(Setting.key.token))
                                xhr.onload = function () {
                                    appUtils.hideLoading(loading)
                                    var json;
                                    if (xhr.status != 200) {
                                        console.log('HTTP Error: ' + xhr.status);
                                        return;
                                    }
                                    json = JSON.parse(xhr.responseText).data;
                                    if (!json || typeof json.url != 'string') {
                                        console.log('Invalid JSON: ' + xhr.responseText);
                                        return;
                                    }
                                    if (meta.filetype == 'file') {
                                        callback(json.url, {text: json.original});
                                    } else {
                                        callback(json.url);
                                    }
                                };
                                formData = new FormData();
                                formData.append('file', file, file.name);
                                xhr.send(formData);
                            }, 100)
                        };
                    },
                    init_instance_callback: editor => {
                        if (this.value) {
                            editor.setContent(this.value)
                        }
                        editor.on('NodeChange Change KeyUp SetContent', () => {
                            this.$emit('input', editor.getContent())
                            editor.isNotDirty = 1
                        })
                    },
                    setup(editor) {
                        editor.on('FullscreenStateChanged', e => {
                            this.fullscreen = e.state
                        })
                    }
                })
            },
            // 设置编辑器内容
            setContent(value) {
                window.tinymce.get(this.tinymceId).setContent(value)
            },
            // 获取编辑器内容
            getContent() {
                window.tinymce.get(this.tinymceId).getContent()
            }
        }
    }
</script>

<style>
    #tinymce p {
        margin: 0;
    }

    .tinymce {
        padding: 20px;
        border-radius: 10px;
        background: #fff;
        width: 100%;
    }

    .tinymce-container {
        position: relative;
        width: 100%;
    }

    .tinymce-container >>> .mce-fullscreen {
        z-index: 10000;
    }

    .tinymce-textarea {
        visibility: hidden;
        z-index: -1;
    }

    .editor-custom-btn-container {
        position: absolute;
        right: 4px;
        top: 4px;
        /*z-index: 2005;*/
    }

    .fullscreen .editor-custom-btn-container {
        z-index: 10000;
        position: fixed;
    }

    .editor-upload-btn {
        display: inline-block;
    }

    .mce-edit-area + .mce-statusbar {
        opacity: 0;
        height: 0;
    }
</style>
